<template>
    <div style="-webkit-print-color-adjust:exact;">
        <canvas v-if="canvasId && renderComponent" width="1000" height="520" :id="canvasId" v-on:touchmove="handleTouchMove" class="canvas"
                v-on:touchstart="handleTouchStart" v-on:touchend="handleTouchEnd" v-on:mousedown="handleMouseDown"
                v-on:mouseup="handleMouseUp" v-on:mousemove="handleMouseMove"/>
        <v-btn v-if="isEditable" @click="clearImage" color="primary" text>Clear Image</v-btn>
        <v-btn v-if="isEditable" @click="saveState" color="secondary" class="ml-2">Save Image</v-btn>
    </div>
</template>

<script>
    import {EventBus} from '../../../../EventBus';
    export default {
        name: "EstimateCanvas",
        data() {
            return {
                canvasId: null,
                mouse: {
                    current: {
                        x: 0,
                        y: 0
                    },
                    previous: {
                        x: 0,
                        y: 0
                    },
                    down: false
                },
                cHeight: 520,
                cWidth: 1000,
                c: '',
                context: '',
                cleared: true,
                renderComponent: true
            }
        },
        methods: {
            draw: function () {
                if (this.mouse.down) {
                    this.ctx.lineTo(this.currentMouse.x, this.currentMouse.y);
                    this.ctx.strokeStyle ="#14b507";
                    this.ctx.lineWidth = 2;
                    this.ctx.stroke();
                }
            },
            handleMouseDown: function (event) {
                this.cleared = false;
                this.mouse.down = true;
                this.mouse.current = {
                    x: event.pageX,
                    y: event.pageY
                };
                this.ctx.moveTo(this.currentMouse.x, this.currentMouse.y)
            },
            handleTouchStart(event) {
                if (event.target === this.c) {
                    event.preventDefault();
                }
                this.cleared = false;
                this.mouse.current = this.getTouchPos(this.c, event);
                const touch = event.touches[0];
                const mouseEvent = new MouseEvent("mousedown", {
                    clientX: touch.clientX,
                    clientY: touch.clientY
                });
                this.c.dispatchEvent(mouseEvent);
            },
            handleTouchEnd(event) {
                if (this.cleared) return;
                if (event.target === this.c) {
                    event.preventDefault();
                }
                const mouseEvent = new MouseEvent("mouseup", {});
                this.c.dispatchEvent(mouseEvent);
            },
            getTouchPos(canvasDom, touchEvent) {
                const rect = canvasDom.getBoundingClientRect();
                return {
                    x: touchEvent.touches[0].clientX - rect.left,
                    y: touchEvent.touches[0].clientY - rect.top
                };
            },
            handleMouseUp: function () {
                if (this.cleared) return;
                this.mouse.down = false;
            },
            handleMouseMove: function (event) {
                if(this.cleared) return;
                this.mouse.current = {
                    x: event.pageX,
                    y: event.pageY
                };
                this.draw(event)
            },
            handleTouchMove(event) {
                if (event.target === this.c) {
                    event.preventDefault();
                }
                if(this.cleared) return;
                const touch = event.touches[0];
                const mouseEvent = new MouseEvent("mousemove", {
                    clientX: touch.clientX,
                    clientY: touch.clientY
                });
                this.c.dispatchEvent(mouseEvent);
            },
            saveState() {
                const canvasContents = this.c.toDataURL();
                const data = { image: canvasContents, date: Date.now() };
                this.estimate.image = JSON.stringify(data);
                EventBus.$emit('message', {message: `Image Saved`, type:'success'});
            },
            loadState() {
                if (this.estimate.image) {
                    const data = JSON.parse(this.estimate.image);
                    const image = new Image();
                    const c = document.getElementById(this.canvasId);
                    const ctx = this.c.getContext("2d");
                    image.onload = function () {
                        ctx.clearRect(0, 0, c.width, c.height);
                        ctx.drawImage(image, 0, 0); // draw the new image to the screen
                    };
                    image.src = data.image;
                }
            },
            clearImage() {
                this.c.width = this.c.width;
                this.ctx.clearRect(0, 0, this.c.width, this.c.height);
                this.forceRerender();
            },
            forceRerender() {
                // Remove my-component from the DOM
                this.renderComponent = false;

                this.$nextTick(() => {
                    // Add the component back in
                    this.renderComponent = true;
                    if (this.estimate && this.estimate._id) {
                        this.canvasId = this.estimate._id;
                    } else {
                        this.canvasId = makeid(10);
                    }
                    setTimeout(() => {
                        this.c = document.getElementById(this.canvasId);
                        if (this.c) {
                            this.ctx = this.c.getContext('2d');
                        }
                    }, 500);
                });
            },
        },
        computed: {
            currentMouse: function () {
                const rect = this.c.getBoundingClientRect();
                return {
                    x: this.mouse.current.x - rect.left,
                    y: this.mouse.current.y - rect.top
                }
            }
        },
        ready() {
            this.ctx.translate(0.5, 0.5);
            this.ctx.imageSmoothingEnabled= false;
        },
        props: {
            isNew: Boolean,
            estimate: {},
            isEditable: Boolean,
            fromEstimateForm: Boolean
        },
        watch: {
            isNew(newVal) {
                if (!newVal) {
                    this.loadState();
                }
            },
            estimate(newVal) {
                if (!newVal.image) {
                    if (this.ctx) {
                        this.clearImage();
                    }
                } else {
                    this.loadState();
                }
            }
        },
        mounted() {
            if (this.estimate && this.estimate._id) {
                this.canvasId = this.estimate._id;
            } else {
                this.canvasId = makeid(10);
            }
            setTimeout(() => {
                this.c = document.getElementById(this.canvasId);
                this.ctx = this.c.getContext('2d');
                this.ctx.clearRect(0,0,800,800);
                this.loadState();
            }, 500);
            EventBus.$on('estimate-reset', () => {
                this.clearImage();
            });
        }
    }

    function makeid(length) {
        let result           = '';
        let characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let charactersLength = characters.length;
        for ( let i = 0; i < length; i++ ) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }
</script>

<style scoped>
    .canvas {
        background: url('../../../../assets/car-outline.png') !important;
    }
</style>
